import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Paper,Typography } from '@mui/material';
import Table from '@msi/cobalt-react/table';

const PanelScoringRules = () => {
  const scoring = useSelector((state) => 
    state.scoring.scoring
);

  return (
    <Box sx={{ backgroundColor: (theme) => theme.palette.secondary.main, color: (theme) => theme.palette.text.main, pl: 2, pt: 2, pb: 2, height: '100%' }}>
      <Typography variant="h4">Scoring Rules</Typography>
      <Box sx={{ mt: 2, mr: 2 }}>
        <Paper sx={{ backgroundColor: (theme) => theme.palette.secondary.main}}>
          <Table
            columns={[
              {
                field: 'stage',
                header: 'Activity',
              },
              {
                field: 'score',
                header: 'Points Awarded',
              },
              {
                field: 'category',
                header: 'Category',
              },
              {
                field: 'id',
                header: 'Id',
              }
            ]}
            tableContent={scoring
              ?.filter((stage) => stage.enabled)
              .map((stage) => ({
                stage: stage.stage,
                score: stage.score,
                category: stage.category,
                id: stage.id,
              }))}
            condensed={false}
          />
        </Paper>
      </Box>
    </Box>
  );
};

export default PanelScoringRules;

